<template>
  <div>
    <div class="contact-form-button-container" v-if="!isFormVisible">
      <el-button type="primary" size="mini" plain icon="el-icon-plus" @click="showForm">
        {{ $t('component.contacts.addContact') }}
      </el-button>
    </div>
    <form @submit.prevent="saveContact" v-if="isFormVisible">
      <div class="contact-form-container">
        <div class="contact-form-item contact-phone" :class="{error: isPhoneError}">
          <label for="phone">{{ $t('component.contacts.form.labelPhone') }}:</label>
          <input type="text"
                 v-model.trim="msisdn"
                 id="phone"
                 :class="{'checkInProgress': isCheckPhoneInProgress}"
                 @keyup="checkPhone($event)">
          <div class="contact-form-item-error name-error" v-if="formError && isPhoneError">
            <ul>
              <li v-if="isPhoneEmpty">{{ $t('component.contacts.form.errorPhoneRequired') }}</li>
              <li v-if="!isPhoneEmpty && !isPhoneValid">{{ $t('component.contacts.form.errorPhoneInvalid') }}</li>
              <li v-if="isCheckPhoneError">{{ $t('component.contacts.form.errorPhoneCheck') }}</li>
              <li v-if="!isPhoneUnique">{{ $t('component.contacts.form.errorPhoneNotUnique') }}</li>
            </ul>
          </div>
        </div>
        <div class="contact-form-item contact-name">
          <label for="name">{{ $t('component.contacts.form.labelName') }}:</label>
          <input type="text"
                 v-model.trim="description"
                 maxlength="30"
                 id="name">
          <div class="contact-form-item-error phone-error" v-if="formError && isNameEmpty">
            <ul>
              <li>{{ $t('component.contacts.form.errorName') }}</li>
            </ul>
          </div>
        </div>
        <div class="contact-form-buttons">
          <el-tooltip :content="$t('component.contacts.form.tooltipButtonSave')" placement="top">
            <el-button type="primary" icon="el-icon-check" plain native-type="submit" size="mini" aria-label="save"></el-button>
          </el-tooltip>
          <el-tooltip :content="$t('component.contacts.form.tooltipButtonCancel')" placement="top">
            <el-button type="danger" icon="el-icon-close" plain size="mini" @click="hideForm" aria-label="cancel"></el-button>
          </el-tooltip>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ContactsFormMixin from '@/common/mixins/Contacts/Form.mixin'

export default {
  name: 'ContactsForm',
  mixins: [ContactsFormMixin]
}
</script>
